/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.3.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */

/**
 * @module OutputStream
 * @author nuintun
 * @author Kazuhiko Arase
 */
var OutputStream = /*#__PURE__*/ (function () {
  function OutputStream() {}
  OutputStream.prototype.writeBytes = function (bytes, offset, length) {
    if (offset === void 0) {
      offset = 0;
    }
    if (length === void 0) {
      length = bytes.length;
    }
    for (var i = 0; i < length; i++) {
      this.writeByte(bytes[i + offset]);
    }
  };
  OutputStream.prototype.flush = function () {
    // The flush method
  };
  OutputStream.prototype.close = function () {
    this.flush();
  };
  return OutputStream;
})();

export { OutputStream };
